<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active">Print Coupons Log</li>
        </ol>
        <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          
       <div class="panel-body1 locationform">
           <div class="row ">
              <div class="col-md-3">
                  <div id="search-box">
                    <div class="form-group">
                      <input
                        type="text"
                        class="search-query form-control"
                        placeholder="Search"
                        v-model="searchText"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <button
                      type="button"
                      v-on:click="getAllLeads(1)"
                      class="btn btn-outline-primary"
                    >
                      Search
                    </button>
                  </div>
                </div>
             
               
           <div class="col-md-12">
               <table
                  class="table table-striped table-bordered"
                  cellspacing="0"
                  width="100%"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Download File</th>
                      <th>Status</th>
                      <th>Exporter Name</th>
                     <th>Generate ON</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(item, index) in printlog_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td><a :href="item.URL | appendHost(host_url)"> {{ item.fileName  }}</a></td>
                      <td>{{ item.Status }}</td>
                   <td>{{ item.first_name+" "+item.last_name }}</td>
                 <td>{{format_date(item.created_date)}}</td>
                   
                  </tr>
                </tbody>
                </table>
                <!--end table-->
                  <paginate
                  :page-count="TotalPage"
                  :click-handler="getAllLeads"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
           </div>
           </div>
       </div>
       
      </div>
    </div>
    
  </div>
</template>
<script>
import moment from 'moment'

import Paginate from 'vuejs-paginate';

import commonServices from '../services/common-services';
export default {
  name: 'paymentExportFileLog',
  data() {
    return {
      printlog_data: [],
      TotalPage: 1,
      searchText: '',
      pageSize: 10,
      currentPage: 1,
      showAddEnq:false,
      ErrorMessage:'',
      SuccessMessage:'',
      host_url:''
    };
  },
  components: {
    Paginate,
  },
  methods: {
   
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllLeads(pageNum) {
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      commonServices
        .get('kspgAPI/DownloadCoupons/loglist', params)
        .then((response) => {
          const {
            printlog_data,
            totalItems,
            currentPage,
            TotalPage,
            host_url,
          } = response.data;
          this.printlog_data = printlog_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.host_url =  host_url;
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
             this.$router.push({ name: 'login'});
          }
        });
    },
    format_date(value){
         if (value) {
          return moment(String(value)).format('DD-MM-YYYY h:mm:ss a')
          }
      },
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  mounted() {
    this.getAllLeads(1)
  },
  filters: {
        truncate: function (text, length, suffix) {
            if(!text){
              return text;
            }
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
         appendHost: function(url,host_url){
      if(!url){
        return url;
      }
      return host_url + url;
    }
    },
   
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.btn-outline-primary{color:#007bff;border-color:#007bff}
.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}
.btn-outline-primary.focus,
.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}
.btn-outline-primary.disabled,
.btn-outline-primary:disabled{color:#007bff;background-color:transparent}
.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,.show>
.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>
.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}
</style>
